import { createContext, useContext, useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      setLoading(false)
    })

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      setUser(session?.user ?? null)

      // Handle token refresh
      if (event === 'TOKEN_REFRESHED') {
        console.log('Token refreshed successfully')
      }

      // Handle session errors
      if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
        setUser(null)
      }
    })

    // Auto-refresh token every 50 minutes (tokens expire after 60 minutes)
    const refreshInterval = setInterval(async () => {
      const { data: { session }, error } = await supabase.auth.getSession()

      if (session && !error) {
        // Refresh the session
        const { error: refreshError } = await supabase.auth.refreshSession()
        if (refreshError) {
          console.error('Failed to refresh session:', refreshError)
          // If refresh fails, sign out
          await supabase.auth.signOut()
        } else {
          console.log('Session refreshed automatically')
        }
      }
    }, 50 * 60 * 1000) // 50 minutes

    return () => {
      subscription.unsubscribe()
      clearInterval(refreshInterval)
    }
  }, [])

  const signIn = (email, password) => {
    return supabase.auth.signInWithPassword({ email, password })
  }

  const signUp = (email, password) => {
    return supabase.auth.signUp({ email, password })
  }

  const signOut = () => {
    return supabase.auth.signOut()
  }

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signUp, signOut }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
